"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responsePropertyToExclusiveProperty = void 0;
var searchResponseToResultPage_1 = require("@/transformers/searchResponseToResultPage");
var ResultPageState_1 = require("@/pages/search/states/ResultPageState");
var format_1 = require("@/utils/format");
var rentInclusiveToBoolOrNull = function (inclusive) {
    if (inclusive === ResultPageState_1.ResultIncludeManagementFee.INCLUDE)
        return true;
    if (inclusive === ResultPageState_1.ResultIncludeManagementFee.EXCLUDE)
        return false;
    return null;
};
var toHighRes = function (imageUrl) {
    return imageUrl.replace('/wp406_229/', '/wp1800_1200/');
};
exports.responsePropertyToExclusiveProperty = function (type, lang, imgDomain) { return function (property) {
    var address = [[property.streetNo, property.streetName].join(' '), property.districtName].join(', ');
    var photos = property.propertyPhotoImages && property.propertyPhotoImages.length ? property.propertyPhotoImages.map(function (it) { return it.path; }) : searchResponseToResultPage_1.photoStrToPhotos(property.propertyPhoto, property.id).map(function (it) { return searchResponseToResultPage_1.toPhotoPath(it.photoName, it.photoType, imgDomain); });
    var imageUrl = property.exclusivePhoto ? property.exclusivePhoto : photos && photos.length ? photos[0] : '';
    var isRentInclusive = rentInclusiveToBoolOrNull(searchResponseToResultPage_1.reverseMapLeaseInc(property.leaseInc));
    var sqft = property.netSize ? property.netSize : property.grossSize;
    var link = "/" + lang + "/property/" + (property.salePrice > 0 || property.isSaleSTO ? 'buy' : 'rent') + "/" + format_1.default.normalize(property.buildingName) + "/" + property.id;
    var isJointSoleAgent = property.banners && property.banners.length ? property.banners[0].label.length === 6 || property.banners[0].label.length === 16 : false;
    return {
        address: address,
        bathrooms: property.bathrooms,
        bedrooms: property.bedrooms,
        buildingName: property.buildingName,
        districtName: property.districtName,
        imageUrl: toHighRes(imageUrl),
        isNoImage: !property.hasExclusivePhoto,
        isJointSoleAgent: isJointSoleAgent,
        isSoleAgent: !isJointSoleAgent,
        isRentInclusive: isRentInclusive,
        isSaleSubjectToOffer: property.isSaleSTO === 1,
        isRentSubjectToOffer: property.isLeaseSTO === 1,
        pricePrefix: 'HK$',
        propertyId: property.id,
        rentPrice: property.leasePrice * 1000,
        salePrice: property.salePrice,
        sqft: sqft,
        sqftIsNet: property.netSize > 0,
        link: link,
    };
}; };
